import { Component, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppleSigninComponent = /** @class */ (function () {
    function AppleSigninComponent() {
        this.color = Color.black;
        this.type = Type.Apple;
    }
    /**
     * @return {?}
     */
    AppleSigninComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    AppleSigninComponent.prototype.singninIn = /**
     * @return {?}
     */
    function () {
        AppleID.auth.signIn();
    };
    /**
     * @return {?}
     */
    AppleSigninComponent.prototype.ngAfterViewChecked = /**
     * @return {?}
     */
    function () {
        AppleID.auth.init({
            clientId: this.clientId,
            scope: this.scope,
            redirectURI: this.redirectURI,
            state: this.state
        });
    };
    AppleSigninComponent.decorators = [
        { type: Component, args: [{
                    selector: 'apple-signin',
                    template: "<button id=\"appleid-signin\" (click)=\"singninIn()\" [attr.data-color]=\"color\" [attr.data-type]=\"type\"> Sign In with Apple </button>",
                    styles: [":host button{display:flex;border:none;cursor:pointer;padding:0}"]
                }] }
    ];
    AppleSigninComponent.propDecorators = {
        clientId: [{ type: Input }],
        scope: [{ type: Input }],
        redirectURI: [{ type: Input }],
        state: [{ type: Input }],
        color: [{ type: Input }],
        type: [{ type: Input }]
    };
    return AppleSigninComponent;
}());
/** @enum {string} */
var Color = {
    black: 'black',
    light: 'light',
};
/** @enum {string} */
var Type = {
    SignIn: 'sign in',
    SignUp: 'sign up',
    Apple: 'apple',
    Continue: 'continue',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppleSigninModule = /** @class */ (function () {
    function AppleSigninModule() {
    }
    AppleSigninModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AppleSigninComponent],
                    imports: [],
                    exports: [AppleSigninComponent]
                },] }
    ];
    return AppleSigninModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AppleSigninComponent, AppleSigninModule, Color, Type };
//# sourceMappingURL=ng8-apple-signin.js.map
